import React, { useState, useEffect, useRef } from "react";
import "../styles/pages/Making.scss";
import { toast } from "react-toastify";
import ArrowButton from "../components/utils/button/ArrowButton";
import { useNavigate, useLocation } from "react-router-dom";
import FinalReadingModal from "../components/reading/FinalReadingModal";
import LandScapeModal from "../components/utils/modal/LandScapeModal";
import ErrorModal from "../components/utils/modal/ErrorModal";
import StoryImage from "../components/utils/StoryImage";
import StoryContentToggle from "../components/utils/StoryContentToggle";
import AudioBookSelectionModal from "../components/audiobook/AudioBookSelectionModal";
import Flipbook from "../components/flipbook/Flipbook";
import NovelFrame from "../components/flipbook/NovelFrame";
import {
  getAudioBookList,
  getAudioBookDetail,
  deleteAudioBooks,
} from "../api/LibraryAPI";
import { ERROR } from "../utils/Constants";
import { getLocalizedAssetPath } from "../utils/getLocalizedLogo";

const AudioReading = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const audioRef = useRef(new Audio());

  const USER_ID = localStorage.getItem("userID");
  const BOOK_ID = localStorage.getItem("book_id");
  const pageName = location.state?.pageName || "";
  const bookID = location.state?.bookID || BOOK_ID;

  const [bookData, setBookData] = useState(null);
  const [story, setStory] = useState([]);
  const [index, setIndex] = useState(-1);
  const [audioSrc, setAudioSrc] = useState("");
  const [bgImage, setBgImage] = useState("");
  const [contentText, setContentText] = useState("");
  const [currentAudioIndex, setCurrentAudioIndex] = useState(null);
  const [showFinalReadingModal, setShowFinalReadingModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [audioBookAll, setAudioBookAll] = useState([]);
  const [audioBookList, setAudioBookList] = useState([]);
  const [showAudioBookModal, setShowAudioBookModal] = useState(false);
  const [isFlipping, setIsFlipping] = useState(false);
  const [isBookOpened, setIsBookOpened] = useState(false);
  const [showFlipbook, setShowFlipbook] = useState(false);
  const [showTitleOnCover, setShowTitleOnCover] = useState(true);

  useEffect(() => {
    const fetchAudioBook = async () => {
      const res = await getAudioBookList(bookID);

      if (!res.success || res.data.audiobook_count === 0) {
        setErrorMessage("오디오북이 없습니다.");
        setShowErrorModal(true);
        return;
      }

      setAudioBookAll(res.data);
      setAudioBookList(res.data.audiobooks);
      setShowAudioBookModal(true);
    };
    fetchAudioBook();
  }, []);

  useEffect(() => {
    fetchAudioBook();
  }, []);

  const fetchAudioBook = async () => {
    const res = await getAudioBookList(bookID);
    if (!res.success || res.data.audiobook_count === 0) {
      setErrorMessage("오디오북이 없습니다.");
      setShowErrorModal(true);
      return;
    }
    setAudioBookAll(res.data);
    setAudioBookList(res.data.audiobooks);
    setShowAudioBookModal(true);
  };

  const handleSelectAudioBook = async (audiobook_id) => {
    const res = await getAudioBookDetail(audiobook_id);
    if (!res.success) {
      setErrorMessage("오디오북을 불러올 수 없습니다");
      setShowErrorModal(true);
      return;
    }
    const data = res.data;
    setBookData({
      title: data.book_title,
      bookcover: data.bookcover,
      style: data.style,
    });
    console.log("res data", data);
    setStory(data.pages || []);
    setIndex(-1);
    setShowAudioBookModal(false);
  };

  useEffect(() => {
    if (index === -1) {
      if (bookData) {
        setAudioSrc(""); // 표지일 때는 오디오 없음
        setBgImage(bookData.bookcover);
        setContentText(bookData.title);
      }
      return;
    }
    if (!story || !story[index]) return;
    const current = story[index];
    console.log("current??!", current);
    setBgImage(current.background);
    setContentText(current.page_content);
    setAudioSrc(current.audio_url);
  }, [index, story]);

  useEffect(() => {
    if (!audioSrc || currentAudioIndex === index) return;
    audioRef.current.pause();
    audioRef.current.src = audioSrc;
    audioRef.current
      .play()
      .then(() => {
        setCurrentAudioIndex(index);
      })
      .catch((err) => console.error("오디오 재생 실패:", err));
  }, [audioSrc, index]);

  const handleButtonClick = (direction) => {
    setIndex((prev) => {
      let newIndex = prev + (direction === "left" ? -1 : 1);
      if (newIndex < -1) newIndex = -1;
      else if (newIndex >= story.length) {
        setShowFinalReadingModal(true);
        return prev;
      }
      return newIndex;
    });
  };

  // 오디오북 삭제
  const handleDeleteAudioBooks = async (selectedIds) => {
    if (!selectedIds || selectedIds.length === 0) return;

    const res = await deleteAudioBooks(selectedIds);

    if (res.success) {
      toast.success(`${res.data.deleted_count}개의 오디오북을 삭제했어요.`);

      const updated = await getAudioBookList(bookID);

      if (!updated.success || updated.data.audiobooks.length === 0) {
        navigate("/myStorybook");
        return;
      }

      setAudioBookAll(updated.data);
      setAudioBookList(updated.data.audiobooks);
    } else {
      toast.error(res.errorMessage || "삭제 중 오류가 발생했어요.");
      setShowErrorModal(true);
    }
  };

  const handleExit = () => {
    setShowFinalReadingModal(false);
  };

  return (
    <>
      {bookData?.style === "graphic_novel" ||
      bookData?.style === "그림 소설" ? (
        <NovelFrame
          isFlipping={isFlipping}
          showLogo={false}
          isOpened={showFlipbook}
        >
          {showFlipbook ? (
            <div className="flipbook-fade-in-wrapper">
              <Flipbook
                index={index}
                story={story}
                setStory={setStory}
                pageCount={story.length}
                setShowFinalModal={setShowFinalReadingModal}
                setIsFlipping={setIsFlipping}
                handleChangeBackground={null}
                setIndex={setIndex}
                isReadOnly={true}
                title={bookData?.title}
                cover={bookData?.bookcover}
              />
            </div>
          ) : (
            /* 책장 표지 오버레이 */
            <div
              className={`book-shelf-cover ${isBookOpened ? "opened" : ""}`}
              onClick={() => {
                if (isBookOpened) return;
                setIsBookOpened(true);
                setTimeout(() => {
                  setShowFlipbook(true);
                  setIndex(0);
                }, 600);
              }}
            >
              <div className="result-book-container">
                <div className="result-book">
                  <div className="cover-content">
                    <div className="cover-title-toggle-tabs">
                      <button
                        className={`toggle-tab ${showTitleOnCover ? "active" : ""}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowTitleOnCover(true);
                        }}
                      >
                        <img
                          src={
                            showTitleOnCover
                              ? getLocalizedAssetPath("/images/makingBranch/title-on.svg")
                              : getLocalizedAssetPath("/images/makingBranch/title-off.svg")
                          }
                          alt="제목 보기"
                        />
                      </button>
                      <button
                        className={`toggle-tab ${!showTitleOnCover ? "active" : ""}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowTitleOnCover(false);
                        }}
                      >
                        <img
                          src={
                            showTitleOnCover
                              ? getLocalizedAssetPath("/images/makingBranch/cover-off.svg")
                              : getLocalizedAssetPath("/images/makingBranch/cover-on.svg")
                          }
                          alt="표지 보기"
                        />
                      </button>
                    </div>
                    <img src={bookData?.bookcover} alt="cover" />
                    <h2
                      className={`novel-title ${!showTitleOnCover ? "hide" : ""}`}
                    >
                      {bookData?.title}
                    </h2>
                  </div>
                </div>
                <figure className="result-book-left">
                  <img
                    src="/images/utils/modal/novelFinalModal/book-left.svg"
                    alt="spine"
                  />
                </figure>
                <figure className="result-book-bottom">
                  <img
                    src="/images/utils/modal/novelFinalModal/book-bottom.svg"
                    alt="pages"
                  />
                </figure>
              </div>
            </div>
          )}
        </NovelFrame>
      ) : (
        <section className="stories-section">
          {showErrorModal && (
            <ErrorModal
              error_message={errorMessage}
              onClose={() => {
                setShowErrorModal(false);
                navigate("/storyland");
              }}
            />
          )}
          <StoryImage src={bgImage || audioBookAll?.bookcover} alt="bg-img" />
          <StoryContentToggle
            showTitleOnCover={showTitleOnCover}
            setShowTitleOnCover={setShowTitleOnCover}
          />
          <div className="story-ui-layer">
            <ArrowButton
              onClick={() => handleButtonClick("left")}
              direction="left"
              className="story-btn prev-btn"
            />
            <ArrowButton
              onClick={() => handleButtonClick("right")}
              direction="right"
              className="story-btn next-btn"
            />
            <div
              className={`story-contents-container ${
                !showTitleOnCover ? "hide" : ""
              }`}
            >
              <ul className="story-contents">
                <li className="origin-text">
                  {contentText}
                  <div className="text-stroke">{contentText}</div>
                </li>
              </ul>
            </div>
            <div className="numbering">{index + 1}</div>
          </div>
        </section>
      )}
      <audio ref={audioRef} onEnded={() => {}} playsInline />

      {showFinalReadingModal && (
        <FinalReadingModal
          onBack={() => setIndex(0)}
          pageName={pageName}
          onClose={handleExit}
          isAudio={true}
        />
      )}
      {showAudioBookModal && (
        <AudioBookSelectionModal
          audiobooks={audioBookList}
          onSelect={handleSelectAudioBook}
          onClose={() => {
            setShowAudioBookModal(false);
            navigate("/myStorybook");
          }}
          bookID={bookID}
          onReadTextBook={(book_id) => {
            navigate("/reading", {
              state: {
                pageName,
                bookID: book_id,
              },
            });
          }}
          onDeleteSelected={handleDeleteAudioBooks}
        />
      )}
      <LandScapeModal />
    </>
  );
};

export default AudioReading;
